const state = () => ({
  list: []
})

const getters = {
  list: (state) => state.list
}

const mutations = {
  list(state, list) {
    state.list = list
  }
}

const actions = {
  async list({ commit }, params = {}) {
    this.$axios.setHeader('Access-Control-Allow-Origin', '*')
    const res = await this.$axios.get(
      process.env.KOKUCH_API_ENDPOINT + '/api/event/1.0/search/',
      { params }
    )

    const list = []
    if (res.data.results_returned >= 1) {
      for (let i = 0; i < res.data.events.length; i++) {
        list.push({
          name: res.data.events[i].title,
          image: res.data.events[i].image_url,
          url: res.data.events[i].event_url,
          start_date: res.data.events[i].start_date,
          end_date: res.data.events[i].end_date
        })
      }
    }
    commit('list', list)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
